import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrandProtection = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "brand-shield",
			d: "M7.49 1.78C7.8 1.59 8.2 1.59 8.51 1.78C9.97 2.68 11.43 3.28 12.95 3.6C13.27 3.67 13.5 3.95 13.5 4.28V7.3C13.5 10.41 11.56 12.83 8.3 14.18C8.11 14.26 7.89 14.26 7.7 14.18C4.44 12.83 2.5 10.41 2.5 7.3V4.28C2.5 3.95 2.73 3.67 3.05 3.6C4.57 3.28 6.03 2.68 7.49 1.78Z",
			stroke: "currentColor",
			strokeWidth: 1.1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "brand-inset",
			d: "M8 4.25C9.05 4.89 10.13 5.36 11.25 5.65V7.3C11.25 9.31 10.13 10.93 8 12.1C5.87 10.93 4.75 9.31 4.75 7.3V5.65C5.87 5.36 6.95 4.89 8 4.25Z",
			opacity: .45,
			stroke: "currentColor",
			strokeWidth: .8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "brand-trace",
			d: "M7.49 1.78C7.8 1.59 8.2 1.59 8.51 1.78C9.97 2.68 11.43 3.28 12.95 3.6C13.27 3.67 13.5 3.95 13.5 4.28V7.3C13.5 10.41 11.56 12.83 8.3 14.18C8.11 14.26 7.89 14.26 7.7 14.18C4.44 12.83 2.5 10.41 2.5 7.3V4.28C2.5 3.95 2.73 3.67 3.05 3.6C4.57 3.28 6.03 2.68 7.49 1.78Z",
			pathLength: 1,
			opacity: 0,
			stroke: "currentColor",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "brand-scan",
			d: "M4.25 5.1H11.75",
			opacity: 0,
			stroke: "currentColor",
			strokeWidth: 1,
			strokeLinecap: "round"
		})
	]
});
export default SvgBrandProtection;
